import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure17 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'bar',
      height: '1000px',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
        fontFamily: 'Montserrat'
      }
    },

    colors: ['#4573be', '#6fad56'],

    credits: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },

    plotOptions: {
      series: {
        borderWidth: 0,
        marker: {
          symbol: 'circle',
          enabled: false,
          states: {
            hover: {
              enabled: true,
              radius: 5
            }
          }
        }
      }
    },

    exporting: {
      enabled: false
    },

    xAxis: [{
      categories: [ "Mongolie 2019", "Sénégal 2019", "Iraq 2012", "Pakistan 2014", "Viet Nam 2010", "Cameroun 2014", "Guatemala 2014", "Kirghizistan 2013", "Ghana 2017", "Équateur 2014", "Guinée-Bissau 2019", "Inde 2012", "Pérou 2019", "Géorgie 2020", "Nicaragua 2014", "Mexique 2014", "Népal 2011", "Arménie 2013", "Afrique du Sud 2015", "Mali 2017", "Burkina Faso 2019", "Sierra Leone 2011", "Ouganda 2020", "Bangladesh 2010", "Bénin 2019", "Éthiopie 2019", "République-Unie de Tanzanie 2015", "Malawi 2020", "Nigéria 2019", "Togo 2019", "Rwanda 2014", "Niger 2014" ],
      lineColor: "#d7d7d7",
      tickColor: "#d7d7d7",
      tickLength: 16,
      labels: {
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        }
      },
    }],
    yAxis: [{
      labels: {
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        },
      },
      max: 5000,
      min: 0,
      tickInterval: 500,
      gridLineWidth: 2,
      title: {
        text: null,
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      }
    }],
    tooltip: {
      shared: true,
      useHTML: true,
      hideDelay: 500,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      style: {
        padding: 0
      }
    },
    legend: {
      enabled: false,
    },

    series: [{
      name: 'Hommes',
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [ 4595, 2637, 3216, 3765, 3088, 2257, 2671, 2298, 2246, 2218, 2055, 1768, 1996, 1630, 1925, 1290, 1182, 1117, 721, 1467, 987, 682, 781, 1151, 1028, 699, 540, 555, 523, 521, 330, 272 ],
    },
    {
      name: 'Femmes',
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [ 3004, 2911, 2892, 2530, 2336, 1925, 1874, 1560, 1440, 1373, 1333, 1288, 1192, 1079, 995, 903, 865, 835, 785, 706, 612, 608, 606, 543, 501, 459, 428, 399, 278, 269, 268, 188 ]
    }
  ]
}